import { useEffect, useMemo, useState } from "react";
import { useGroupApi, imageUrl, MEAL_LABELS } from "../groupApi";
import LoadingComp from "../../../components/LoadingComp";
import { Sheet } from "./ui";

// Reuses the app's existing recipe endpoints: GET /search (text search) and
// GET /recipes (its tag-grouped suggestions). No second food database.
export default function AddFoodModal({ title, mealType, showMealPicker, onPick, onClose, busy }) {
  const { call } = useGroupApi();
  const [q, setQ] = useState("");
  const [meal, setMeal] = useState(mealType);
  const [suggestions, setSuggestions] = useState(null);
  const [results, setResults] = useState(null);
  const [searching, setSearching] = useState(false);

  useEffect(() => {
    let ignore = false;
    call("recipes", { method: "GET" })
      .then((groups) => {
        if (ignore) return;
        const seen = new Set();
        const flat = [];
        (groups || []).forEach((g) =>
          (g.foods || []).slice(0, 4).forEach((f) => {
            if (!seen.has(f.recipe_id)) { seen.add(f.recipe_id); flat.push(f); }
          })
        );
        setSuggestions(flat.slice(0, 24));
      })
      .catch(() => !ignore && setSuggestions([]));
    return () => { ignore = true; };
  }, [call]);

  useEffect(() => {
    const term = q.trim();
    if (term.length < 3) { setResults(null); return; }
    let ignore = false;
    setSearching(true);
    const t = setTimeout(async () => {
      try {
        const groups = await call(`search?q=${encodeURIComponent(term)}`, { method: "GET" });
        if (ignore) return;
        const seen = new Set();
        const flat = [];
        (groups || []).forEach((g) => (g.foods || []).forEach((f) => {
          if (!seen.has(f.recipe_id)) { seen.add(f.recipe_id); flat.push(f); }
        }));
        setResults(flat);
      } catch (e) {
        if (!ignore) setResults([]);
      } finally {
        if (!ignore) setSearching(false);
      }
    }, 350);
    return () => { ignore = true; clearTimeout(t); };
  }, [q, call]);

  const list = results !== null ? results : suggestions;
  const heading = useMemo(() => (results !== null ? "نتایج جستجو" : "پیشنهادها"), [results]);

  return (
    <Sheet title={title} onClose={onClose}>
      {showMealPicker && (
        <div className="grpChoice">
          {Object.entries(MEAL_LABELS).map(([k, label]) => (
            <button key={k} type="button" className={`grpChip ${meal === k ? "grpChip-active" : ""}`} onClick={() => setMeal(k)}>
              {label}
            </button>
          ))}
        </div>
      )}
      <input
        className="grpInput"
        autoFocus
        placeholder="جستجوی غذا (حداقل ۳ حرف)"
        value={q}
        onChange={(e) => setQ(e.target.value)}
      />
      <div className="grpSectionTitle" style={{ marginTop: 14 }}>{heading}</div>
      {(list === null || searching) && <LoadingComp />}
      {list && !searching && list.length === 0 && (
        <p className="grey-2 caption-1 yekan">غذایی پیدا نشد</p>
      )}
      <div className="grpFoodGrid" style={{ opacity: busy ? 0.5 : 1, pointerEvents: busy ? "none" : "auto" }}>
        {(searching ? [] : list || []).map((f) => (
          <button key={f.recipe_id} type="button" className="grpFood" onClick={() => onPick(f, meal)}>
            {f.image_path ? <img src={imageUrl(f.image_path)} alt="" loading="lazy" /> : <img alt="" />}
            <p>{f.recipe_name}</p>
          </button>
        ))}
      </div>
    </Sheet>
  );
}
